module.exports = __webpack_public_path__ + "static/media/IMG_1534.9802831b.JPG";